import { useMutation } from "@apollo/client";
import { MULTI_FIELD_UPDATE_MUTATION } from "../mutations/mutations";

export function useMultiFieldUpdate(options = {}) {
    const [container] = useMutation(MULTI_FIELD_UPDATE_MUTATION, options)

    /**
     * @param {Object<string, string>[]} data
     */
    return (data) => {
        return container({
            variables: {
                rules: JSON.stringify(data)
            }
        })
    }
}